module.exports = __webpack_public_path__ + "img/clos-luce-art.f66f1465.png";